import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export class BannerModel {
  constructor(public icon: IconDefinition, public text: string, public button: { text: string; link?: string[]; externalLink?: string }) {}
}
